var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row mb-2" }, [
    _c(
      "div",
      { staticClass: "col-4" },
      [
        _c(
          "v-select",
          {
            staticClass: "form-control",
            attrs: {
              options: _vm.typeOptions,
              disabled: !_vm.canWrite || _vm.typeOptions.length === 0,
              clearable: false,
              searchable: "",
              filterable: ""
            },
            model: {
              value: _vm.typeModel,
              callback: function($$v) {
                _vm.typeModel = $$v
              },
              expression: "typeModel"
            }
          },
          [_c("div", { attrs: { slot: "no-options" }, slot: "no-options" })]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-5" },
      [
        _vm.isDropdown
          ? _c(
              "v-select",
              {
                staticClass: "form-control",
                attrs: {
                  options: _vm.fields,
                  disabled: !_vm.canWrite || _vm.fields.length === 0,
                  clearable: false,
                  searchable: "",
                  filterable: ""
                },
                model: {
                  value: _vm.dropdownValueModel,
                  callback: function($$v) {
                    _vm.dropdownValueModel = $$v
                  },
                  expression: "dropdownValueModel"
                }
              },
              [_c("div", { attrs: { slot: "no-options" }, slot: "no-options" })]
            )
          : _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.valueModel,
                  expression: "valueModel"
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                disabled: !_vm.canWrite || _vm.fields.length === 0
              },
              domProps: { value: _vm.valueModel },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.valueModel = $event.target.value
                }
              }
            })
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "col-3 d-flex" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-outline-danger ml-auto",
          on: {
            click: function($event) {
              return _vm.$emit("delete", _vm.newValue.id)
            }
          }
        },
        [
          _c("i", { staticClass: "fa fa-trash" }),
          _vm._v(" " + _vm._s(_vm.resource("Button_Remove")) + "\n        ")
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }